module.exports = __webpack_public_path__ + "img/left.300cf608.png";